import getNamespace from "./getNamespace/";
import useCustomerTranslation from "./useCustomerTranslation";
import getTranslatedValue from "./getTranslatedValue";

export default {
  getNamespace,
  getTranslatedValue,
  useCustomerTranslation,
};
